<div id="planogram-builder-builder">
  <mat-horizontal-stepper
    linear
    #mystepper
    id="planogram-stepper"
    [selectedIndex]="stepper_index"
    (selectionChange)="setStepperIndex($event)"
  >
    <ng-template matStepperIcon="edit" let-index="index">
      {{ index + 1 }}
    </ng-template>

    <mat-step [completed]="true" label="Library">
      <div class="stepper-actions-container">
        <button class="back-button">
          <img
            style="margin-right: 1vw; width: 1vw"
            src="../../assets/back.svg"
            alt="back"
          />Go Back
        </button>
        <button class="next" mat-raised-button color="warn">Next</button>
      </div>
    </mat-step>
    <mat-step [completed]="npds_data_valid" label="Admin Guidelines Input">
      <div class="stepper-actions-container">
        <button (click)="moveBackToLibrary()" class="back-button">
          <img
            style="margin-right: 1vw; width: 1vw"
            src="../../assets/back.svg"
            alt="back"
          />Go Back
        </button>
        <button
          (click)="createGuidelinesVersion()"
          mat-raised-button
          [disabled]="!npds_data_valid"
          class="next"
          color="warn"
        >
          Next
        </button>
      </div>
      <ng-template matStepContent>
        <app-admin-guidelines-input
          (checkNpdsValidationInGuidelines)="
            checkNpdsValidationInGuidelines($event)
          "
          [payload]="payload"
        >
        </app-admin-guidelines-input>
      </ng-template>
    </mat-step>
    <mat-step label="Review Planogram">
      <div class="stepper-actions-container">
        <button (click)="publishPlanogram()" mat-raised-button color="warn">
          SAVE & EXIT
        </button>
      </div>
      <ng-template matStepContent>
        <app-planogram-new-builder
          [isReset]="isReset"
          [is_display]="stepper_index == 2"
          [planogram_id]="planogram_id"
          (resetSkusInPlanogram)="resetPlanogram($event)"
          [planogram_details]="{}"
        ></app-planogram-new-builder>
      </ng-template>
    </mat-step>
  </mat-horizontal-stepper>
  <app-loader [is_show_loader]="(is_show_loader | async)!"></app-loader>
</div>
